import './scss/styles.scss';
import { API_URL, CDN_URL, SETTINGS, AppStateComponents, } from './utils/constants';
import { ProductAPI } from './components/model/ProductsAPI';
import { EventEmitter } from './components/base/events';
import { cloneTemplate, ensureElement } from './utils/utils';
import { AppState } from './components/model/AppData';
import { PageView } from './components/view/partial/Page';
import { ModalView } from './components/view/base/Modal';
import { ProductItemView, ProductItemModalView, } from './components/view/partial/ProductCard';
import { BasketView } from './components/view/partial/Basket';
import { ProductItemBasket } from './components/view/partial/ProductBasket';
import { OrderView } from './components/view/partial/Order';
import { ContactsView } from './components/view/partial/Contact';
import { SuccessView } from './components/view/partial/Success';
const api = new ProductAPI(CDN_URL, API_URL);
const events = new EventEmitter();
const main = new PageView(document.body, events);
const modal = new ModalView(ensureElement(SETTINGS.modalContainer), events);
const app = new AppState(api, {}, events);
const templates = {
    productsTemplate: ensureElement(SETTINGS.productCardMainTemplate),
    cardPreviewTemplate: ensureElement(SETTINGS.productCardPreviewTemplate),
    cardBasketTemplate: ensureElement(SETTINGS.productCardBasketTemplate),
    basketTemplate: ensureElement(SETTINGS.basketTemplate),
    orderTemplat: ensureElement(SETTINGS.orderTemplate),
    contactsTemplate: ensureElement(SETTINGS.contactsTemplate),
    successTemplate: ensureElement(SETTINGS.successTemplate),
};
const components = {
    basket: new BasketView(cloneTemplate(templates.basketTemplate), events),
    order: new OrderView(cloneTemplate(templates.orderTemplat), events),
    contacts: new ContactsView(cloneTemplate(templates.contactsTemplate), events),
    success: new SuccessView(cloneTemplate(templates.successTemplate), {
        onClick: () => {
            events.emit(AppStateComponents.MODAL.CLOSE);
            modal.close();
        },
    }),
};
// Получаем данные с сервера
app.laodProducts().catch((err) => console.log(err));
// Изменяем каталог
events.on(AppStateComponents.PRODUCT.CHANGE, () => {
    main.products = Array.from(app.products.values()).map((item) => {
        const product = new ProductItemView(cloneTemplate(templates.productsTemplate), {
            onClick: () => events.emit(AppStateComponents.PRODUCT.SELECT, item),
        });
        return product.render({
            id: item.id,
            title: item.title,
            image: item.image,
            category: item.category,
            price: item.price,
        });
    });
});
// открытие карточки
events.on(AppStateComponents.PRODUCT.SELECT, (item) => {
    main.locked = true;
    const product = new ProductItemModalView(cloneTemplate(templates.cardPreviewTemplate), {
        onClick: () => {
            events.emit(AppStateComponents.PRODUCT.TO_BASKET, item);
        },
    });
    modal.render({
        content: product.render({
            id: item.id,
            title: item.title,
            image: item.image,
            category: item.category,
            description: item.description,
            price: item.price,
            selected: item.selected,
        }),
    });
});
// добавляем product в basket
events.on(AppStateComponents.PRODUCT.TO_BASKET, (item) => {
    item.selected = true;
    app.addProductInBasket(item);
    app.basketTotal += item.price;
    main.counter = app.getAmountProductInBasket();
    modal.close();
});
// при закрытии модалки прокрутка разрешается
events.on(AppStateComponents.MODAL.CLOSE, () => (main.locked = false));
// евент на открытие корзины
events.on(AppStateComponents.BASKET.OPEN, () => {
    main.locked = true;
    const basketContent = Array.from(app.basket.values()).map((item, index) => {
        const productInBasket = new ProductItemBasket(cloneTemplate(templates.cardBasketTemplate), {
            onClick: () => events.emit(AppStateComponents.BASKET.DELETE, item),
        });
        return productInBasket.render({
            index: index + 1,
            title: item.title,
            price: item.price,
        });
    });
    modal.render({
        content: components.basket.render({
            list: basketContent,
            total: app.basketTotal,
        }),
    });
});
// удаление товара из корзины
events.on(AppStateComponents.BASKET.DELETE, (item) => {
    item.selected = false;
    app.deleteProductInBasket(item.id);
    main.counter = app.basket.size;
    app.basketTotal -= item.price;
    components.basket.total = app.basketTotal;
    if (app.basket.size === 0)
        components.basket.disableButton();
});
// открытие order
events.on(AppStateComponents.BASKET.ORDER, () => {
    app.setOrderItems();
    modal.render({
        content: components.order.render({
            address: '',
            valid: false,
            errors: [],
        }),
    });
});
// валидация order
events.on(AppStateComponents.ORDER.ERROR, (dataErr) => {
    components.order.valid = !dataErr.payment && !dataErr.address;
    components.order.errors = Object.values(dataErr)
        .filter((errStr) => !!errStr)
        .join(' ');
});
// изменение order в AppState
events.on(AppStateComponents.ORDER.INPUT, (data) => {
    app.setOrderField(data.field, data.value);
});
// открытие формы контактов
events.on(AppStateComponents.ORDER.SUBMIT, () => {
    modal.render({
        content: components.contacts.render({
            email: '',
            phone: '',
            valid: false,
            errors: [],
        }),
    });
});
// валидация contact
events.on(AppStateComponents.CONTACT.ERROR, (dataErr) => {
    components.contacts.valid = !dataErr.email && !dataErr.phone;
    components.contacts.errors = Object.values(dataErr)
        .filter((errStr) => !!errStr)
        .join(' ');
});
// изменение order в AppState
events.on(AppStateComponents.CONTACT.INPUT, (data) => {
    app.setOrderField(data.field, data.value);
});
// отправка данных покупки на сервер
events.on(AppStateComponents.CONTACT.SUBMIT, () => {
    app
        .orderProducts()
        .then((answer) => {
        events.emit(AppStateComponents.CONTACT.TO_SUCCESS, answer);
        components.order.btnsInActive();
        main.counter = 0;
        components.order.clearingForms();
        components.contacts.clearingForms();
    })
        .catch((err) => {
        console.log(err);
    });
});
// открытие окна подтверждения
events.on(AppStateComponents.CONTACT.TO_SUCCESS, (answer) => {
    modal.render({
        content: components.success.render({ description: answer.total }),
    });
});
